module.exports = __webpack_public_path__ + "media/images/mailer/warning-24-white-b7f2b193045b7bcc881d43959e46f204.png";